import React, { FC } from 'react';
import { Card, Container } from '@mui/material';
import { useUiContext } from 'src/UIProvider';
import { DashboardHeader } from 'src/UIKit/DashboardHeader';
import { Select } from 'src/UIKit/Select';
import { observer } from 'mobx-react-lite';
import { TextInput } from 'src/UIKit/TextInput';
import { useNltdevskeletonCreating } from '../../presenters/useNltdevskeletonCreating';
import { NltdevskeletonImageDropZone } from '../components/categoryImageDropZone';
import { CheckboxAutocompleteSingle } from 'src/modules/categories/ui/components/autocompleteTree';
import { IOSSwitch } from 'src/UIKit/IOSSwitch';

export const NltdevskeletonCreatingView: FC = observer(() => {
    const { t } = useUiContext();
    const { nltdevskeleton, parent, errors, typeOptions, onChange, onCreateNltdevskeleton, onSelectCategory, onChangeCategory, categories, loading, onActiveSwitch } = useNltdevskeletonCreating();

    return (
        <Container maxWidth="xl">
            <DashboardHeader title={t('content.createContent')} buttonTitle={t('save')} onPress={onCreateNltdevskeleton} isDisabledButton={loading}/>
            <NltdevskeletonImageDropZone />
            <Card sx={{ p: 2, mb: 2 }}>
                <TextInput label={t('common.name')} name='name' onChange={onChange} value={nltdevskeleton?.name} error={errors} required />
                {/*<TextInput label={t('common.type')} name='type' onChange={onChange} value={nltdevskeleton?.type} error={errors} required />*/}
                {/* <TextInput label={t('common.description')} name='description' onChange={onChange} value={nltdevskeleton?.description} /> */}
                {/* <TextInput label={t('common.slug')} name='slug' onChange={onChange} value={nltdevskeleton?.slug} error={errors} required /> */}
                <Select label={t('common.type')} name='type' onChange={onChange} value={nltdevskeleton?.type || ''} error={errors} options={typeOptions} />
                <CheckboxAutocompleteSingle name='category_id' title={t('content.parentCategory') + '*'} optionList={categories} onSelect={onSelectCategory} value={parent?.id} onChange={onChangeCategory} error={errors}/>
                <IOSSwitch label={t('common.free')} secondLabel={t('common.noFree')} name="free" onChange={onActiveSwitch} checked={nltdevskeleton?.is_free} />
            </Card>
        </Container>
    );
})
